import script from "./ProgramVersionTargetsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionTargetsCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionTargetsCard.vue?vue&type=style&index=0&id=3b631810&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b631810"]])

export default __exports__